export const updateDimensions = ({ width, height }) => ({
	type: 'DIMENSIONS_UPDATE',
	width,
	height,
})
